// Source/Care-Popup/Log.ts
var debug = console.debug.bind(`[ \uD83E\uDE79 ]:`);

// Source/Care-Popup/Cart.ts
async function updateItems(updates) {
  debug(`Cart::Update`, updates);
  const response = await fetch(`/cart/update.js`, {
    method: "Post",
    body: JSON.stringify({ updates }),
    headers: {
      "Content-Type": "application/json"
    }
  }).then((response) => response.json()).catch((exception) => {
    debug(`Network Failure`, exception);
  });
  debug(`Response`, response);
}
async function addItems(items) {
  debug(`Cart::Add`, items);
  const response = await fetch(`/cart/add.js`, {
    method: "Post",
    body: JSON.stringify({ items }),
    headers: {
      "Content-Type": "application/json"
    }
  }).then((response) => response.json()).catch((exception) => {
    debug(`Network Failure`, exception);
  });
  debug(`Response`, response);
}

// Source/Care-Popup/Component.ts
class CarePopup extends HTMLElement {
  controller;
  data;
  constructor() {
    super();
    const json = this.$script.textContent;
    this.data = JSON.parse(json);
  }
  connectedCallback() {
    this.controller = new AbortController;
    this.setupListeners();
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  setupListeners() {
    const { signal } = this.controller;
    const selectStandard = this.selectStandard.bind(this);
    this.$standard_button.addEventListener("click", selectStandard, { signal });
    const selectAdvanced = this.selectAdvanced.bind(this);
    this.$advanced_button.addEventListener("click", selectAdvanced, { signal });
    this.$close.addEventListener("click", () => {
      this.dataset.open = String(false);
    });
  }
  async selectStandard() {
    this.$prompt.loading = true;
    debug(`Component::Select-Standard`);
    const entries = this.data.services.map((service) => service.key).map((key) => [key, 0]);
    if (entries.length) {
      const updates = Object.fromEntries(entries);
      await updateItems(updates);
    }
    this.finish();
  }
  async selectAdvanced() {
    this.$prompt.loading = true;
    debug(`Component::Select-Advanced`);
    const { period, data } = this;
    const { products, services } = data;
    const to_add = products.map((product) => {
      const service = product.service;
      const plan = period === "Monthly" ? service.plan : null;
      return {
        quantity: product.quantity,
        variant: service.variant,
        plan
      };
    });
    const to_remove = services.map((service) => ({ ...service, id: `${service.variant}:${service.plan}` }));
    if (to_remove.length) {
      const updates = to_remove.map((remove) => [remove.key, 0]);
      const entries = Object.fromEntries(updates);
      await updateItems(entries);
    }
    if (to_add.length) {
      const items = to_add.map((item) => ({
        selling_plan: item.plan,
        quantity: item.quantity,
        id: item.variant
      }));
      await addItems(items);
    }
    await this.finish();
  }
  async finish() {
    this.$prompt.checkout();
    this.$prompt.loading = false;
    document.querySelector(`#swym-plugin .swym-close-btn`)?.click();
  }
  close() {
    this.dataset.open = String(false);
  }
  open() {
    this.dataset.open = String(true);
  }
  get $advanced_period() {
    return this.querySelector(`.Care-Plan[ data-type = 'Advanced' ] input:checked`);
  }
  get $advanced_button() {
    return this.querySelector(`.Care-Plan[ data-type = 'Advanced' ] button`);
  }
  get $standard_button() {
    return this.querySelector(`.Care-Plan[ data-type = 'Standard' ] button`);
  }
  get $close() {
    return this.querySelector(`.Care-Popover-Close`);
  }
  get $script() {
    return this.querySelector(`script`);
  }
  get $prompt() {
    return this.closest(`care-prompt`);
  }
  get period() {
    const select = this.$advanced_period;
    return select.value;
  }
}

// Source/Care-Popup/mod.ts
customElements.define("care-popup", CarePopup);
